import React from "react"
import './card.css'

export const CPCard = ({children,className = "",onClickChange}) => {
    return (
        <div className={`container_card ${className}` } onClick={onClickChange}>
            {children}
        </div>
    );
}